import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button, P, Span } from 'components/Ui';
import { lockIcon } from 'images';
import styles from './styles.scss';

const formatDate = (date) => moment(date).format('MMM Do YYYY');

const PayBillLockout = ({
  onOpenPayBill,
  isInactiveShipToLockout,
  isEquipmentPickupLockout,
}) => {
  const equipmentPickupMessage = (
    <div>
      <p>
        <Span translationKey={'LockoutEquipment1'}>
          We are currently scheduled to come pick up your equipment on{' '}
        </Span>
        <span className={styles.pickupDate}>[{formatDate(moment())}]</span>
      </p>
      <p>
        <Span translationKey={'LockoutEquipment2'}>
          At this time you won’t be able to order additional products, but you
          can still pay any outstanding bills and view your delivery history. If
          you have questions or need to change anything about your equipment
          pickup, please feel free to call Customer Service at{' '}
        </Span>
        <Span
          className={styles.phoneNumber}
          translationKey={'PhoneNumber:LockoutEquipment'}
        >
          866-407-7873
        </Span>
        .
      </p>
      <P translationKey={'LockoutEquipment3'}>
        We hope to be able to serve you again in the future.
      </P>
    </div>
  );

  const inactiveMessage = (
    <div>
      <p>
        <Span translationKey={'LockoutInactive'}>
          This location is currently inactive. You are not able to order more
          products or receive delivery at this time. If you would like to make a
          payment, please click here. If you have any questions please contact a
          Customer Service Representative at{' '}
        </Span>
        <Span
          className={styles.phoneNumber}
          translationKey={'PhoneNumber:LockoutInactive'}
        >
          800-728-5508
        </Span>
        .
      </p>
    </div>
  );

  const payBillMessage = (
    <div>
      <p>
        <Span translationKey={'LockoutPayBill'}>
          If you would like to make a payment, please click here. If you have
          any questions please contact a Customer Service Representative at{' '}
        </Span>
        <Span
          className={styles.phoneNumber}
          translationKey={'PhoneNumber:LockoutPayBill'}
        >
          800-728-5508
        </Span>
        .
      </p>
    </div>
  );

  const title = isEquipmentPickupLockout
    ? 'We’re sorry to see you go!'
    : 'We’re sorry!';

  const message = isEquipmentPickupLockout
    ? equipmentPickupMessage
    : isInactiveShipToLockout
    ? inactiveMessage
    : payBillMessage;

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <img src={lockIcon} alt="lockIcon" className={styles.lock} />
        <Span className={styles.title}>{title}</Span>
        <span className={styles.message}>{message}</span>
        <Button
          className={styles.btn}
          text="Pay Bill"
          onClick={onOpenPayBill}
        />
      </div>
    </div>
  );
};

PayBillLockout.propTypes = {
  onOpenPayBill: PropTypes.func.isRequired,
  isInactiveShipToLockout: PropTypes.bool,
  isEquipmentPickupLockout: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({});

export default connect(mapStateToProps, null)(PayBillLockout);
